import type { StanDataColumn } from '@/components/core-components/StanDataRow/StanDataRow.types';

/**
 * Column width percentages for the funnels list data rows.
 * Used by both the header and individual funnel rows to maintain alignment.
 */
export const FUNNELS_LIST_COLUMN_WIDTHS = {
    name: 20,
    sales: 10,
    pages: 10,
    leads: 10,
    views: 10,
    url: 40,
} as const;

/**
 * Header column definitions for the funnels list StanDataRowGroup
 */
export const FUNNELS_LIST_HEADER_COLUMNS: StanDataColumn[] = [
    {
        id: 'name',
        name: 'Name',
        width: FUNNELS_LIST_COLUMN_WIDTHS.name,
    },
    {
        id: 'sales',
        name: 'Sales',
        width: FUNNELS_LIST_COLUMN_WIDTHS.sales,
        className: 'hidden md:block',
    },
    {
        id: 'pages',
        name: 'Pages',
        width: FUNNELS_LIST_COLUMN_WIDTHS.pages,
        className: 'hidden md:block',
    },
    {
        id: 'leads',
        name: 'Leads',
        width: FUNNELS_LIST_COLUMN_WIDTHS.leads,
        className: 'hidden md:block',
    },
    {
        id: 'views',
        name: 'Views',
        width: FUNNELS_LIST_COLUMN_WIDTHS.views,
        className: 'hidden md:block',
    },
    {
        id: 'url',
        name: 'URL',
        width: FUNNELS_LIST_COLUMN_WIDTHS.url,
        className: 'hidden md:block',
    },
];

/**
 * Generate CSS grid-template-columns string from the funnels list column widths
 */
export function getFunnelsListGridTemplate(): string {
    return Object.values(FUNNELS_LIST_COLUMN_WIDTHS)
        .map(width => `${width}%`)
        .join(' ');
}
